export default {
	pageSize: 10,						//表格每一页条数
	parseData: function (res) {
		return {
			data: res,
			rows: res.data,		//分析行数据字段结构
			total: res.count,		//分析总数字段结构
			msg: res.msg,			//分析描述字段结构
			code: res.code				//分析状态字段结构
		}
	},
	filter: function (data, fields, multiple = true) {
		if (multiple) {
			const value = [];
			if (data.length > 0 && fields.length > 0) {
				for (const key in data) {
					const item = {};
					for (const field of fields) {
						item[field] = data[key][field]
					}
					value.push(item)
				}
			}
			return value
		}else {
			const item = {};
			for (const field of fields) {
				item[field] = data[field]
			}
			return item;
		}
	},
	request: {
		page: 'page',					//规定当前分页字段
		pageSize: 'limit',			//规定一页条数字段
		keyword: 'keyword'				//规定搜索字段
	},
	props: {
		label: 'label',					//映射label显示字段
		value: 'value',					//映射value值字段
	}
}
